import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { CrisisMonitoringPageBg } from "@/components/site/CrisisMonitoringPageBg";

import { pageSchemas } from "@/lib/seo/page-schema";
const DESCRIPTION =
  "Perceptica открива ранните сигнали за репутационни кризи, проследява развитието им в реално време и предоставя анализи и препоръки за бърза и уверена реакция.";

export const Route = createFileRoute("/bg/media-analysis/crisis-monitoring")({
  head: () => ({
    meta: [
      { title: "Кризисен мониторинг и анализ при кризи | Perceptica" },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: "Кризисен мониторинг и анализ при кризи | Perceptica" },
      { property: "og:description", content: DESCRIPTION },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Кризисен мониторинг и анализ при кризи | Perceptica" },
      { name: "twitter:description", content: DESCRIPTION },
      { property: "og:url", content: "https://perceptica.com/bg/media-analysis/crisis-monitoring" },
      ...ogImageMeta("bg", "/media-analysis/crisis-monitoring"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/media-analysis/crisis-monitoring", service: { name: "Кризисен мониторинг", description: "Кризисен мониторинг и анализ при кризи от Perceptica за Югоизточна Европа.", serviceType: "Кризисен мониторинг" } }),
  }),
  component: CrisisMonitoringPageBg,
});
